<template>
	<div style="width: 100%;height: 100%;" class="chart">

	</div>
</template>
<script>
    import echarts from 'echarts'

    function setOption(args) {
        if(args.serving[0] == 0 && args.served[0] == 0){
            args.serving[0] = 0.01;
            args.served[0] = 0.01;
            args.total[0] = 0.02;
        }
        var max = Math.max.apply(null,args.total);
		var option = {
            legend:{
                type :　'scroll',
				orient: 'horizontal',
				left: '10%',
				itemGap: 5,
				itemWidth: 4,
				itemHeight: 12,
				padding: 12,
				bottom: '5%',
				data: ['在保','过保']
            },
			xAxis: {
                max :　max,
                show: false,
			},
			grid: [{
				left: '11%', //grid 组件离容器左侧的距离。
				right: '12%', //grid 组件离容器右侧的距离。
			//	top:'6%',
			//	bottom: '2%', //grid 组件离容器下侧的距离。
				top:'1%',
				bottom: '1%', //grid 组件离容器下侧的距离。
                containLabel : true
                }],
			yAxis: [{
				axisLine: ' none',
				axisTick: ' none',	
                offset:'45',		
				axisLabel: {
					textStyle:{
                        color:'#6e6d6d',
                        fontSize:'14'
                    }
				},
               // data : ["技术公告扫描告警","安全风险评估告警","资源状态检查告警","硬件类告警"]
                data : args.name
			},{
				axisLine: ' none',
				axisTick: ' none',	
                name: '过保',
                nameLocation:'end',
                nameTextStyle:{
                    color:'#f7b84f'
                },
                nameGap:'0',
                show:true,		
				axisLabel: {
					textStyle:{
                        color:'#6e6d6d',
                        fontSize:'14'
                    }
				},
                data : []
			},{
				show :true,
                name:'在保',
                nameLocation:'end',
                nameTextStyle:{
                    color:'#32b6d3'
                },
                nameGap:'0',
                data : [],              
                axisLine :　{
                    show :　false
                },
                splitLine : {
                    show :　false
                },
                axisTick : {
                    show : false
                }
			}],
            series: [{
                name: '条',
                data: args.serving,
                type: 'bar',
                yAxisIndex : 0,
                //设置柱子的宽度
                barMaxWidth : 8,
                stack : 'b',
                // label:{
                //     show:false
                // },     
                itemStyle:{
                    normal:{
                        color : '#32b6d3',                 
                    },
                },
                label:{
                    normal:{
                        show:true,
                        position : 'insideLeft',
                       // backgroundColor:'#32b6d3',
                       // borderWidth:'1',
                      //  padding : 5,
                      //  borderRadius:25,
                        distance :　-45,
                        color:'#32b6d3',
                        fontSize:'12',
                        formatter: function(params){
                            if(params.value == 0.01){
                                return 0;
                            }
                        },
                    },
                },
                z:2
            },{
                name: '黄框',
                data: args.served,
                type: 'bar',
                barGap : '-100%',
                yAxisIndex : 1,
                stack:'b' ,
                //设置柱子的宽度
                barMaxWidth : 8,
                itemStyle:{
                    normal:{                    
                                        
                        color : '#f7b84f',          
                    },
                },
                label:{
                    normal:{
                        show:true,
                        position : 'insideRight',
                       // backgroundColor:'#f7b84f',
                        //borderWidth:'1',
                       // padding : 5,
                       // borderRadius:25,
                        distance :　-42,
                        color:'#f7b84f',
                        fontSize:'12',
                        formatter: function(params){
                            if(params.value == 0.01){
                                return 0;
                            }
                        },
                        
                    },
                    
                },
                z:1
            },{
                name: "外框",
                data: args.total,
                type: 'bar',
                yAxisIndex : 2,
                barGap : '-100%',
                barWidth : 18, 
                label:{
                    normal:{
                        show:false,                    
                    }
                } ,      
                itemStyle:{
                    normal:{
                        color : '#fff',
                        borderColor : '#32b6d3',
                        borderWidth :' 2',
                    },                   
                },
                z:0
            },{
                name: "外圆",
                data: [0],
                type: 'scatter',
                yAxisIndex : 2,
                symbolSize:25,
                label:{
                    normal:{
                        show:false,                    
                    }
                } ,      
                itemStyle:{
                    normal:{
                        color : '#32b6d3',
                        opacity: 1
                    },                   
                },
                z:2
            },{
                name: "外圆",
                data: args.total,
                type: 'scatter',
                yAxisIndex : 2,
                symbolSize:25,
                label:{
                    normal:{
                        show:false,                    
                    }
                } ,      
                itemStyle:{
                    normal:{
                        color : '#f7b84f',
                        opacity: 1
                    },                   
                },
                z:2
            }]
        };
        return option;
    }
    export default {
        name: 'HorBar',
        props: ['args'],
        methods: {
            initChart() {
                let _this = this
                window.addEventListener('resize', function() {
                    this.myChart.resize()
                }.bind(this))
            },
            resize: function() {
                this.myChart.resize()
            },
            reDrawChart: function(args) {
                var container = this.$el;
                console.log(container)
                this.initChart();
                this.myChart = echarts.init(container);
                this.myChart.setOption(setOption(args), false);
            }
        },
        mounted: function(el) {
        }

    }
</script>


// WEBPACK FOOTER //
// src/components/echarts/horBar.vue